export default "__VITE_ASSET__C7K9MZET__"